"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentLoom = currentLoom;
async function currentLoom(deps) {
    const registry = deps.registry;
    // Check for mono‑loom first
    if (registry.isMonoLoom()) {
        const localPath = registry.getMonoLoomPath();
        return {
            name: '(local)',
            path: localPath,
            exists: localPath ? deps.fs.existsSync(localPath) : false,
            isMonoLoom: true,
        };
    }
    // Multi‑loom mode
    const active = registry.getActiveLoom();
    if (!active) {
        return { name: null, path: null, exists: false, isMonoLoom: false };
    }
    const looms = registry.listLooms();
    const current = looms.find(l => l.path === active);
    const resolved = registry.resolveLoomPath(active);
    return {
        name: current?.name || null,
        path: resolved,
        exists: deps.fs.existsSync(resolved),
        isMonoLoom: false,
    };
}
